import { setQueryString, getQueryString } from '@/utils/UrlUtils';

const INITIAL_STATE = {
  details: {},
  refData: {},
  currentPage: 1,
  formNotValid: false,
  hasFormBeenUpdated: false,
  submitUpdateSuccessful: false,
  submitPolicyInProcess: false,
  memberPolicies: null,
};

export default {
  namespaced: true,

  state: { ...INITIAL_STATE },

  mutations: {
    /**
     * If `resetSubmitUpdateSuccessful` is true, it will also reset `submitUpdateSuccessful` data as well.
     * It is due to when member navigate away from update member details page, we reset all state but we do not want to reset `submitUpdateSuccessful`
     * data as no impact page can only be access while it is true (from vue route safe guard)
     */
    resetMemberDetails(state, resetSubmitUpdateSuccessful = true) {
      const resettedState = { ...INITIAL_STATE };

      if (!resetSubmitUpdateSuccessful) {
        resettedState.submitUpdateSuccessful = state.submitUpdateSuccessful;
      }

      Object.assign(state, resettedState);
    },

    updateMemberDetailsRefData(state, data) {
      state.refData = data;
    },

    updateMemberDetails(state, data) {
      state.details = data;
    },

    updateMemberDetailsPageNum(state, pageNum) {
      state.currentPage = pageNum;

      if (Number(getQueryString('step')) !== Number(pageNum)) {
        setQueryString('step', pageNum);
      }
    },

    updateMemberDetailsFormValid(state, data) {
      state.formNotValid = data;
    },

    updateHasFormBeenUpdated(state, data) {
      state.hasFormBeenUpdated = data;
    },

    updateSubmitUpdateSuccessful(state, data) {
      state.submitUpdateSuccessful = data;
    },

    updateCoverDetails(state, data) {
      state.coverDetails = data;
    },
    
    updateSubmitPolicyInProcess(state, data) {
      state.submitPolicyInProcess = data;
    },

    updateMemberPolicies(state, data) {
      state.memberPolicies = data;
    },
  },

  getters: {
    getSubmitUpdateSuccessfulStatus: (state) => {
      return state.submitUpdateSuccessful;
    },

    getMemberDetailsFormValidationStatus: (state) => {
      return state.formNotValid;
    },

    getMemberDetailsPageReferenceData: (state) => {
      return state.refData;
    },

    getMemberDetails: (state) => {
      return state.details;
    },

    getMemberDetailsPageNum: (state) => {
      return state.currentPage;
    },

    getHasFormBeenUpdated: (state) => {
      return state.hasFormBeenUpdated;
    },

    getCoverDetails: (state) => {
      return state.coverDetails;
    },

    getSubmitPolicyInProcess: (state) => {
      return state.submitPolicyInProcess;
    },
    getMemberPolicies: (state) => {
      return state.memberPolicies;
    },
  },
};
